import { API_URL } from './constants';

const parseSseChunk = (chunk, onEvent) => {
  const blocks = chunk.split('\n\n');
  for (const block of blocks) {
    if (!block.trim()) continue;

    let eventName = 'message';
    let dataLines = [];

    for (const line of block.split('\n')) {
      if (line.startsWith('event:')) {
        eventName = line.slice(6).trim();
      } else if (line.startsWith('data:')) {
        dataLines.push(line.slice(5).trim());
      }
    }

    if (dataLines.length === 0) continue;

    try {
      const data = JSON.parse(dataLines.join('\n'));
      onEvent(eventName, data);
    } catch (e) {
      console.warn('SSE parse error', e);
    }
  }
};

/**
 * Opens an authenticated SSE connection. Returns cleanup function.
 */
export const connectNotificationStream = ({ onEvent, onError }) => {
  const token = localStorage.getItem('user-token');
  if (!token) {
    return () => {};
  }

  const abortController = new AbortController();
  let buffer = '';

  const run = async () => {
    try {
      const response = await fetch(`${API_URL}/notifications/stream`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'text/event-stream'
        },
        signal: abortController.signal
      });

      if (!response.ok) {
        throw new Error(`SSE connection failed (${response.status})`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lastDelimiter = buffer.lastIndexOf('\n\n');
        if (lastDelimiter === -1) continue;

        const complete = buffer.slice(0, lastDelimiter + 2);
        buffer = buffer.slice(lastDelimiter + 2);
        parseSseChunk(complete, onEvent);
      }
    } catch (err) {
      if (err.name === 'AbortError') return;
      onError?.(err);
    }
  };

  run();

  return () => abortController.abort();
};
